// **
// *   /!\  Warning: Symbolic link.
// *        Shared file between apps
// *        CUBE / SHIFT / THOR
// **

import { environment } from '../environments/environment';

declare global {
  interface Window { config: any; }
}

/**
 * Override env with injected configuration 
 * @see /fronts/deploy/inject-appconfigs.js
 */
const config = window.config ?? environment;

export const isDev = !config.PROD;

export const regexp = {
  url: 'https?:\/\/[-A-Za-z0-9+&@#\/%?=~_|!:,.;]+[-A-Za-z0-9+&@#\/%=~_|]'
};

export const sourceProviders = {
  'AWIN': 'Awin',
  'EVO': 'Evo'
};

export const featureFlags = {
  FF_MY_BENCHMARK: config.FF_MY_BENCHMARK,
  FF_API_KEYS_V2: config.FF_API_KEYS_V2,
}

export const settings = {
  keys: {
    captcha: config.CAPTCHA_KEY
  },
  pagination: {
    perPage: 15
  },
  app: {
    url: config.APP_URL,
    SSOEnabled: config.SSO_ENABLED
  },
  api: {
    url: config.SSO_ENABLED ? config.SSO_API_URL : config.API_URL,
    urlPerks: config.SSO_ENABLED ? config.SSO_API_PERKS_URL : config.API_PERKS_URL,
    urlAuthz: config.API_AUTHZ_URL,
    lifetime: 90 * 24 * 60 * 60
  },
  pianoAnalytics: {
    site: config.PIANO_KEY,
    collectDomain: config.PIANO_DOMAIN
  },
  sentry: {
    dsn: config.SENTRY_DSN,
    environment: config.ENVIRONMENT,
    traceSampleRate: config.SENTRY_TRACE_RATE,
    replaysSessionSampleRate: config.SENTRY_REPLAY_SAMPLE_RATE,
    replaysOnErrorSampleRate: config.SENTRY_REPLAY_SAMPLE_RATE_ON_ERROR,
  },
  roles: [
    'ADMIN',
    'TECHNICAL',
    'FINANCE',
    'OFFER',
    'GIFT',
    'SUPPORT',
    'REPORTING'
  ],
  countries: ['FR', 'BE', 'CH'],
};

if (isDev) {
  console.info('Settings', settings)
}